exports = module.exports = require("../../../../_css-loader@0.28.4@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".am-carousel {\n  position: relative;\n}\n.am-carousel-wrap {\n  font-size: 18px;\n  color: #000;\n  background: none;\n  text-align: center;\n  zoom: 1;\n  width: 100%;\n}\n.am-carousel-wrap-dot {\n  display: inline-block;\n  zoom: 1;\n}\n.am-carousel-wrap-dot > span {\n  display: block;\n  width: 8px;\n  height: 8px;\n  margin: 0 3px;\n  border-radius: 50%;\n  background: #ccc;\n}\n.am-carousel-wrap-dot-active > span {\n  background: #888;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.4@css-loader!./node_modules/_postcss-loader@2.0.6@postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/_less-loader@4.1.0@less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A"}}!./node_modules/_antd-mobile@2.2.2@antd-mobile/lib/carousel/style/index.less
// module id = 388
// module chunks = 0